import { useState, useEffect } from 'react';
import api from '@/lib/api';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Fallback counties in case API fails
const FALLBACK_COUNTIES = [
  'Highlands', 'Polk', 'Osceola', 'Hardee', 'DeSoto', 'Okeechobee',
  'Glades', 'Hendry', 'Charlotte', 'Lee', 'Collier', 'Sarasota',
  'Manatee', 'Hillsborough', 'Pinellas', 'Pasco', 'Hernando',
  'Citrus', 'Sumter', 'Lake', 'Orange', 'Seminole', 'Volusia',
  'Brevard', 'Indian River', 'St. Lucie', 'Martin', 'Palm Beach',
  'Broward', 'Miami-Dade'
];

let _cachedCounties = null;

/**
 * Hook to fetch operational counties from the backend.
 * Uses a module-level cache so all components share the same data.
 */
export function useCounties() {
  const [counties, setCounties] = useState(_cachedCounties || FALLBACK_COUNTIES);

  useEffect(() => {
    if (_cachedCounties) {
      setCounties(_cachedCounties);
      return;
    }
    const fetch = async () => {
      try {
        const res = await api.get(`${API_URL}/api/settings/counties`);
        const names = (res.data || []).map(c => c.name).sort();
        if (names.length > 0) {
          _cachedCounties = names;
          setCounties(names);
        }
      } catch {
        // Use fallback silently
      }
    };
    fetch();
  }, []);

  return counties;
}

/** Invalidate cache (call after adding/removing counties in Settings) */
export function invalidateCountiesCache() {
  _cachedCounties = null;
}
